<template>
  <div class="orders">
    <transition
      :name="effect"
      mode="out-in"
    >
      <orders-main-filter v-if="isOrderFilterShowing" />
      <orders-main-view v-else />
    </transition>
  </div>
</template>

<script>
import OrdersMainFilter from './OrdersMainFilter'
import OrdersMainView from './OrdersMainView'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Orders',
  data: () => ({
    effect: 'slide-fade'
  }),
  methods: {
    ...mapActions(['setOrderShowOff']),
    ...mapActions(['clearAllOrderData'])
  },
  components: {
    'orders-main-filter': OrdersMainFilter,
    'orders-main-view': OrdersMainView
  },
  computed: {
    ...mapGetters(['isOrderFilterShowing']),
    ...mapGetters(['duplicatedOrdersFromXml']),
    ...mapGetters(['uploadStatus'])
  },
  watch: {
    isOrderFilterShowing: function (newVal) {
      if (newVal) {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    },
    $route (to, from) {
      this.setOrderShowOff(false)
    },
    uploadStatus: function (newValue) {
      if (
        newValue === 'STATUS_SUCCESS' &&
        this.duplicatedOrdersFromXml.length === 0
      ) {
        this.clearAllOrderData()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/components/orders/empty-cart";

.orders {
  height: 100%;

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter {
    transform: translateY(300px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-400px);
    opacity: 0;
  }
  .leave-fade-enter-active {
    transition: all 0.3s ease;
  }
  .leave-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .leave-fade-enter {
    transform: translateY(-450px);
    opacity: 0;
  }
  .leave-fade-leave-to {
    transform: translateY(450px);
    opacity: 0;
  }
  .alternative-subheader {
    position: initial !important;
  }
}
</style>
